export default "__VITE_ASSET__Bzotxxkl__"